import { Button, Dialog } from "@rio-cloud/rio-uikit";

interface ILoadingDialogProps {
    show: boolean;
    title: string;
    body: string | React.ReactNode;
}

const LoadingDialog = ({ show, title, body }: ILoadingDialogProps) => {
    return (
        <Dialog
            show={show}
            title={(
                <>
                    <div className="spinner mt-1"><div/><div/><div/><div/></div>
                    <span className="ml-5">{title}</span>
                </>
            )}
            body={body}
            showCloseButton={false}
            bsSize={Dialog.SIZE_SM}
        />
    );
}

export default LoadingDialog;